"use strict";
var globalThis = require("../internals/global-this");
var apply = require("../internals/function-apply");
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var fails = require("../internals/fails");
var arraySlice = require("../internals/array-slice");
var Int8Array = globalThis.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function() {
  $toLocaleString.call(new Int8Array(1));
});
var FORCED = fails(function() {
  return [1, 2].toLocaleString() !== new Int8Array([1, 2]).toLocaleString();
}) || !fails(function() {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});
exportTypedArrayMethod("toLocaleString", function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);
